import { useSearchParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import { actionCreators } from "@App/state";
import { useEffect } from "react";

/**
 * A custom hook that reads the garageTypeIds filter from the url query parameters
 * and returns a method to parse the data back to the url query parameters.
 */
export const useGarageTypeIdParameters = () => {
  const dispatch = useDispatch();
  const [searchParams] = useSearchParams();

  const garageTypeIdQuery = searchParams.get("garageTypeIds");

  const garageTypeIds = garageTypeIdQuery
    ?.split(",")
    .map((value) => parseInt(value))
    .filter((value) => !isNaN(value));

  useEffect(() => {
    dispatch(actionCreators.setGarageTypeIds(garageTypeIds ?? []));
  }, [garageTypeIdQuery]);

  const garageTypeIdQueryParams = (): Record<string, string> => {
    return {
      ...(garageTypeIds &&
        garageTypeIds.length > 0 && {
          garageTypeIds: garageTypeIds.join(","),
        }),
    };
  };

  return { garageTypeIdQueryParams };
};
